import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import profileReducer from "./profile/profileSlice";
import tokenReducer from "./token/tokenSlice";
import storageReducer from "./store/storeSlice";
import purchaseRequestSliceReducer from "./purchaseRequest/purchaseRequestSlice"
import userOnboardingReducer from "./userOnboarding/userOnboardingSlice";

export const store = configureStore({
  reducer: {
    profile: profileReducer,
    token: tokenReducer,
    storage: storageReducer,
    purchaseRequest: purchaseRequestSliceReducer,
    userOnboarding: userOnboardingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

setupListeners(store.dispatch);
